// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"f7bf751c","269":"486620c6","309":"32ec182d","543":"498a08ac","888":"6a8991de"}[chunkId] + ".chunk.js";
};